
import createIconComponent from '../utils/createIconComponent';
import { SVG_LOGMEIN_WHITE_YELLOW } from '../../../dist';
import React from 'react';
const LogmeinWhiteYellowIcon = createIconComponent({ content: SVG_LOGMEIN_WHITE_YELLOW, height: 24, width: 85 });
LogmeinWhiteYellowIcon.displayName = 'LogmeinWhiteYellowIcon';
export default LogmeinWhiteYellowIcon;
